
export const mobileCartConfig = (config) => {
    config.mobile_cart = true;
    config.pwa_navbar_desktop_brand_logo = 'https://capturelife.com/img/logo-blue.svg';
}